module.exports = __webpack_public_path__ + "static/media/Jizni_svahy_Uvaly.66dd8894.md";